import(/* webpackMode: "eager" */ "/vercel/path0/noteworthy-site/src/app/layout.tsx");
